"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifyChangePasswordPage = exports.VerifyChangePasswordPageDefaultProps = exports.VERIFY_PASSWORD_CHANGE_QUERY = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var dialog_1 = require("../../elements/dialog");
var modal_layout_1 = require("../../elements/modal-layout");
var use_app_routes_1 = require("../../../hooks/use-app-routes");
var use_lang_1 = require("../../../hooks/use-lang");
var global_style_1 = require("../../elements/global-style");
var html_1 = require("../../elements/html");
var client_1 = require("@apollo/client");
var client_2 = require("@apollo/client");
var icon_button_1 = require("../../elements/icon-button");
var loader_1 = require("../../elements/loader");
var error_dialog_layout_1 = require("../../elements/error-dialog-layout");
// -------- Types -------->
exports.VERIFY_PASSWORD_CHANGE_QUERY = (0, client_2.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query VerifyPasswordChange($id: String!, $code: String!) {\n    verifyPasswordChange(id: $id, code: $code)\n  }\n"], ["\n  query VerifyPasswordChange($id: String!, $code: String!) {\n    verifyPasswordChange(id: $id, code: $code)\n  }\n"])));
exports.VerifyChangePasswordPageDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n  "], ["\n    background: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'))
});
var ModalLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 700px;\n    background: ", ";\n  "], ["\n    width: 100%;\n    max-width: 700px;\n    background: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    background: ", ";\n    border-top: 1px solid ", ";\n    padding: ", " ", " ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-mid'), theme_1.theme.UNIT(6), theme_1.theme.UNIT(5), theme_1.theme.UNIT(6.2))
});
var IntroStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    text-align: center;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "], ["\n    font-size: ", ";\n    display: flex;\n    text-align: center;\n    align-items: center;\n    background: ", ";\n    padding: ", " ", ";\n    padding-top: ", ";\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5), theme_1.theme.UNIT(1))
});
var ContinueButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    line-height: 1.75em;\n    color: ", ";\n    width: 100%;\n    justify-content: center;\n  "], ["\n    display: flex;\n    align-items: center;\n    line-height: 1.75em;\n    color: ", ";\n    width: 100%;\n    justify-content: center;\n  "])), theme_1.theme.COLOR('text'))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    height: 100px;\n    font-size: ", ";\n  "], ["\n    height: 100px;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(16))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ModalLayout: (0, styled_components_1.default)(modal_layout_1.ModalLayout)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ModalLayoutStyles),
  Dialog: (0, styled_components_1.default)(dialog_1.Dialog)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles),
  Intro: styled_components_1.default.header(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled_components_1.default.p(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Controls: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  ContinueButton: (0, styled_components_1.default)(icon_button_1.NextIconButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContinueButtonStyles)
};
var VerifyChangePasswordPage = function (props) {
  var className = props.className,
    path = props.path,
    id = props.id;
  var t = (0, use_lang_1.useLang)();
  var routes = (0, use_app_routes_1.useAppRoutes)();
  var codeParts = (props.code || '').split('?');
  var code = codeParts.length && codeParts[0];
  var _a = (0, client_1.useQuery)(exports.VERIFY_PASSWORD_CHANGE_QUERY, {
      variables: {
        id: id,
        code: code
      }
    }),
    loading = _a.loading,
    error = _a.error,
    _b = _a.data,
    data = _b === void 0 ? {} : _b;
  var introTemplate = t("\n    Thanks, your password has now been changed.<br />Continue below to visit your platform Home page.\n  ");
  var continueIsDisabled = loading;
  var continueLabel = t('Continue');
  if (error) {
    return react_1.default.createElement(error_dialog_layout_1.ErrorDialogLayout, {
      error: error
    });
  }
  var title = t('Change Password Verification');
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(global_style_1.GlobalStyle, null), react_1.default.createElement(My.ModalLayout, null, react_1.default.createElement(My.Dialog, {
    padBody: false,
    title: title,
    controls: react_1.default.createElement(My.Controls, null, react_1.default.createElement(My.ContinueButton, {
      forceAnchorTag: true,
      to: '/',
      disabled: continueIsDisabled
    }, continueLabel))
  }, react_1.default.createElement(My.Intro, null, react_1.default.createElement(My.Content, null, loading ? react_1.default.createElement(My.Loader, {
    spinnerSize: 24
  }) : react_1.default.createElement(html_1.HTML, {
    text: introTemplate
  }))))));
};
exports.VerifyChangePasswordPage = VerifyChangePasswordPage;
exports.VerifyChangePasswordPage.defaultProps = exports.VerifyChangePasswordPageDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;